export default __webpack_public_path__ + "static/media/ID_5.b6834fff.png";